/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

function handleInitialAdjustments({ questionnaire }) {
  return questionnaire.map(question => {
    return question;
  })
}

async function handleQuestionChange({
  question,
  value,
  questionnaireUpdated,
  setQuestionnaire,
  setFieldValue,
  token,
  globalQuestionnaire,
  updateIsLoadingStatus }) { }

const events = {
  handleInitialAdjustments,
  handleQuestionChange
}

export { events };
